/**
 * Responsibility: Implement format prose behavior for the ui/helpers surface.
 * Scope: Owns ui/helpers concerns only; cross-surface orchestration is excluded.
 */
/** Convert lightweight markdown-like text to safe HTML for prose surfaces */
export function formatProse(text: string | null | undefined): string {
  if (!text) return ''

  const safe = String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')

  const formatInline = (value: string): string => value
    .replace(/\*\*(.*?)\*\*/g, '<b style="color:var(--gold);font-weight:bold;">$1</b>')
    .replace(/\*(.*?)\*/g, '<i style="opacity:0.9;">$1</i>')

  const speakerMatch = safe.match(/^\*\*([^*]+)\*\*:\s*([^\n]*)(?:\n{1,2}|$)/)
  if (!speakerMatch) return formatInline(safe).replace(/\n/g, '<br>')

  const actor = speakerMatch[1]?.trim() || 'ACTOR'
  const action = speakerMatch[2]?.trim() || ''
  const bodyRaw = safe.slice(speakerMatch[0].length).replace(/^\n+/, '')
  const actorLine = `<div class="prose-actor-line"><span class="prose-actor-name">${actor}</span><span class="prose-actor-action">${formatInline(action)}</span></div>`
  if (!bodyRaw.trim()) return actorLine
  const bodyHtml = formatInline(bodyRaw).replace(/\n/g, '<br>')
  return `${actorLine}<div class="prose-response">${bodyHtml}</div>`
}
